module.exports = __webpack_public_path__ + "static/media/cocktails-screenshot-min.651daa19.png";